import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcNeutralFillNomargin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "2",
    fill: "none",
    viewBox: "0 0 8 2",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 1a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1"
  }));
}
var IcNeutralFillNomargin = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNeutralFillNomargin));

export { IcNeutralFillNomargin as I };
